import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { DateUtil } from '@admin/shared/util/date';

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en-US',
    load: 'currentOnly',
    ns: 'common',
    supportedLngs: ['en-US', 'de-DE'],
    defaultNS: 'common',
    debug: process.env.NODE_ENV === 'development',

    backend: {
      loadPath:
        process.env.NODE_ENV === 'development'
          ? 'http://localhost:9090/admin/locales/{{lng}}/{{ns}}.json'
          : '/material-admin/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-store',
      },
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // language detector options
    detection: {
      order: ['htmlTag'],
      caches: null,
    },
  } as any)
  .then(() => {
    const lang = i18n.language.substr(0, 2).toLowerCase();
    DateUtil.changeLocale(lang);
  });

export default i18n;
